import React from 'react';
import { Text } from 'core';

const Map = () => {
  return <Text> Not Implemented yet</Text>;
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/modals/map.web.js